import "shared_critical/bootstrap";
import "mortgage/mortgage";
import "app";

// From shared_non_critical
import "bootstrap/js/transition";
import "bootstrap/js/collapse";
import "bootstrap/js/tab";
import "jquery-validation/dist/jquery.validate";
import "jquery-validation/dist/additional-methods";
import "shared_non_critical/common";
import "readmore-js/readmore";

import "@moveinc/rdc-tracking";

// From page non critical
import "shared_non_critical/date_format";
import "shared_non_critical/multiline-ellipsis";
import "highcharts/highcharts";
import "highcharts/modules/broken-axis";

import { defineTemplate } from 'webpack/templates/define_template';

defineTemplate('templates/pagination/gap');
defineTemplate('templates/pagination/next_page');
defineTemplate('templates/pagination/page');
defineTemplate('templates/pagination/paginator');
defineTemplate('templates/pagination/prev_page');

defineTemplate("templates/mortgage/rate_trends_title");
defineTemplate("templates/mortgage/hp_rate_trends_title");
defineTemplate("templates/mortgage/rate_table_card");
defineTemplate("templates/mortgage/rate_table_card_mobile");
defineTemplate("templates/mortgage/rate_table_search_description");
defineTemplate("templates/mortgage/rate_table_detail");
defineTemplate("templates/mortgage/rate_table_detail_mobile");
defineTemplate("templates/mortgage/rate_table_loan_type_checkboxes");
defineTemplate("templates/mortgage/home_equity_rate_table_card");
defineTemplate("templates/mortgage/home_equity_rate_table_card_mobile");
defineTemplate("templates/mortgage/home_equity_rate_table_search_description");
defineTemplate("templates/mortgage/home_equity_rate_table_loan_type_checkboxes");
defineTemplate("templates/mortgage/home_equity_rate_table_loan_type_checkboxes_mobile");

defineTemplate("templates/mortgage/rate_table_message");
defineTemplate("templates/mortgage/home_equity_rate_table_message");
defineTemplate("templates/mortgage/rate_table_provider_disclaimer");
defineTemplate("templates/mortgage/rate_table_rates_per_page");
defineTemplate("templates/mortgage/vu_native_ad");
defineTemplate("templates/mortgage/modal/index");

import "mortgage/rate_trends_graph_helper";
import "mortgage/rates";
import "mortgage/rates/sort";
import "mortgage/rates/pagination";

import "mortgage/rates/views/search_view";
import "mortgage/rates/views/heloc_search_view";
import "mortgage/rates/views/sort_view";
import "mortgage/rates/views/pagination_view";
import "mortgage/rates/views/message_view";

import "mortgage/rates/actions/requests";

import "mortgage/rates/rate_trends";
import "mortgage/rates/rate_page";
import "mortgage/rates/home_equity_rate_page";

if (MOVE.DataStore.getData('controllerName') === 'rates') {
  if (MOVE_DATA.home_equity_rates){
    MOVE.MORTGAGE.HOME_EQUITY_RATES_PAGE.init();
  }else {
    MOVE.MORTGAGE.RATES_PAGE.init();
  }
}



// WEBPACK FOOTER //
// /data/app/rdc-next/app/javascript/packs/mortgage_rate_critical.js